import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { EditGoToTest } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const EditGoToTestPage: FC = () => {
  const { accessToChangeGototest } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToChangeGototest}>
      <CabinetTitlePage title={'Go To Test'} goBack={'/cabinet/facebook/go-to-test'} />
      <EditGoToTest />
    </Guard>
  );
};

export default EditGoToTestPage;
